<template>
  <el-config-provider :size="epSize" :z-index="3000">
    <div id="app" class="min-h-screen">
      <!-- 管理员页面使用独立布局 -->
      <router-view v-if="isAdminRoute" />

      <!-- 普通页面使用AppLayout -->
      <AppLayout v-else />

      <!-- 通知容器 -->
      <NotificationContainer />

      <!-- 公告弹窗 (仅在非管理员页面显示) -->
      <AnnouncementModal v-if="!isAdminRoute" />
    </div>
  </el-config-provider>
</template>

<script>
import { computed, onMounted, onUnmounted, ref } from 'vue'
import { useRoute } from 'vue-router'
import AppLayout from '@/components/layout/AppLayout.vue'
import NotificationContainer from '@/components/ui/NotificationContainer.vue'
import AnnouncementModal from '@/components/ui/AnnouncementModal.vue'

export default {
  name: 'App',
  components: {
    AppLayout,
    NotificationContainer,
    AnnouncementModal
  },
  setup() {
    const route = useRoute()
    const isMobile = ref(false)
    let mq = null
    let resizeTimer = null

    // 检查是否是管理员路由
    const isAdminRoute = computed(() => {
      return route.path.startsWith('/admin')
    })

    const epSize = computed(() => (isMobile.value ? 'large' : 'default'))

    const updateIsMobile = () => {
      if (typeof window === 'undefined') return
      isMobile.value = window.matchMedia('(max-width: 768px)').matches
    }

    // 窗口缩放时禁用过渡动画
    const handleResize = () => {
      document.body.classList.add('resizing')
      clearTimeout(resizeTimer)
      resizeTimer = setTimeout(() => {
        document.body.classList.remove('resizing')
      }, 150)
    }

    onMounted(() => {
      if (typeof window === 'undefined') return
      mq = window.matchMedia('(max-width: 768px)')
      updateIsMobile()

      if (mq.addEventListener) {
        mq.addEventListener('change', updateIsMobile)
      } else if (mq.addListener) {
        mq.addListener(updateIsMobile)
      }

      // 监听窗口缩放
      window.addEventListener('resize', handleResize, { passive: true })
    })

    onUnmounted(() => {
      if (!mq) return
      if (mq.removeEventListener) {
        mq.removeEventListener('change', updateIsMobile)
      } else if (mq.removeListener) {
        mq.removeListener(updateIsMobile)
      }
      mq = null

      // 移除窗口缩放监听
      window.removeEventListener('resize', handleResize)
      clearTimeout(resizeTimer)
    })

    return {
      isAdminRoute,
      epSize
    }
  }
}
</script>
